import {Space} from "antd";
import {LiveEventSubGenInfoFormFields} from "./sub-gen-info";

export function LiveEventGenInfoFormFields() {
  return (
    <Space size={16} direction="vertical" style={{display: "flex"}}>
      <LiveEventSubGenInfoFormFields
        coverImageFieldId="liveEventCoverImage"
        coverImageFieldLabel="Cover Image"
        coverImageFieldPlaceholder=""
        descriptionFieldId="liveEventDescription"
        descriptionFieldLabel="Event description"
        descriptionFieldPlaceholder="What is your event about?"
        nameFieldId="liveEventName"
        nameFieldLabel="Event name"
        nameFieldPlaceholder="e.g Marketing 101"
      />
    </Space>
  );
}
